module.exports = __webpack_public_path__ + "avatar-yi.c791049e.png";